import { render, staticRenderFns } from "./qixi_rule.vue?vue&type=template&id=d236fcca&scoped=true&"
import script from "./qixi_rule.vue?vue&type=script&lang=js&"
export * from "./qixi_rule.vue?vue&type=script&lang=js&"
import style0 from "./qixi_rule.vue?vue&type=style&index=0&id=d236fcca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d236fcca",
  null
  
)

export default component.exports